module.exports = __webpack_public_path__ + "img/fauteuil-19.ee5629ab.jpg";